const Home = () => {
    return (
        <div className="row text-dark">
            <main className="ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">Home</h1>
                </div>
                <p>To-do app Ilker</p>
            </main>
        </div>
    );
};

export default Home;